module.exports = __webpack_public_path__ + "static/media/icon-users.b471392d.svg";